module.exports = __webpack_public_path__ + "media/shared/assets/img/placeholders/placeholder_16x9-db5e8e7562bf4e14bb0911726ddb8bca.jpg";